__webpack_require__.p = "/COMP4702-demos/";